<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-divider">接种预约</a>
              <small class="bc-divider"> > </small>
              <a class="bc-active">所有预约</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h5 id="title">所有预约（施工中）</h5>
          <div id="infos">
            <b-table striped hover :items="items">
              <template v-slot:cell(预约接种)="data">
                <a :href="data.value">选择医院</a>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Appointment",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      assistImg: common.assistImgSrc,
      items: [],
      data: {
        pid: 0,
        name: "",
        birthday: "",
        gender: "",
        allergen: "",
        medical_history: "",
        province: "",
        city: "",
        district: "",
        contact: "",
        contact_phone: "",
        phone: "",
        email: "",
        address: ""
      }
    }
  },
  mounted() {
    common.assureLogin(this);
    this.axios.post(common.apiBase + common.apiService.getPatient, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      this.data = res.data.data;
    }).catch((err) => {
      console.log(err);
    });
    this.axios.post(common.apiBase + common.apiService.getAllAppointment, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      console.log(res.data);
      for (let i of res.data.data) {
        this.items.push({
          "疫苗全称": i['name'],
          "次数": i['dose'],
          "时效": i['effective_time'],
          "接种日期": i['date'],
          "接种医院": i['hospital']
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>

#content {
  padding-left: 2%;
  padding-top: 3vh;
}

#title {
  font-weight: bold;
}

#infos {
  margin-top: 30px;
  font-size: small;
}
</style>